import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isRiskIssueType } from '../../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import DetailsPanel from '../../../generic/DetailsPanel';
import FossabotInlineTip from '../../../shared/ads/FossabotInlineTip';
import { Section } from '../../../shared/vulns/Drawer';
import DependencyDepthMessage from '../DependencyDepthMessage';

import BaseQualityDescription from './BaseQualityDescription';
import RiskDescription from './RiskDescription';
import RiskDocs from './RiskDocs';

import styles from '../IssueContent.module.less';

/**
 * Main issue details for quality issues.
 *
 * Displays the reason this issue was raised and the depth at which
 * the source package is used.
 */
const QualityIssueDetailsIssueDetails: VoidFunctionComponent = () => {
  const qualityIssueDetails = useSelector(IssuesV2Store.selectors.getQualityIssueDetails);

  if (!qualityIssueDetails) {
    return null;
  }
  const { depthMessages, type, sourceId } = qualityIssueDetails;

  const shouldShowRiskInfo = isRiskIssueType(type);
  const shouldShowFossabotTip = type === 'outdated_dependency';
  const shouldShowBaseInfo = !shouldShowRiskInfo;

  return (
    <Section>
      <DetailsPanel id="issue-details-quality-details" target="Issue details">
        <div className={styles.issueDetails}>
          {shouldShowRiskInfo && (<RiskDescription type={type} locator={sourceId} />)}
          {shouldShowBaseInfo && <BaseQualityDescription />}
          {depthMessages && <DependencyDepthMessage depthMessages={depthMessages} />}
          {shouldShowRiskInfo && <RiskDocs type={type} />}
        </div>
        {shouldShowFossabotTip && <FossabotInlineTip />}
      </DetailsPanel>
    </Section>
  );
};

export default QualityIssueDetailsIssueDetails;
